import { Box, Stack, styled, Typography } from "@mui/material"
import busJobs from "../images/busJobs.avif"
import busPosts from "../images/busPosts.avif"
import busQuestions from "../images/busQuestions.avif"
import { Link } from "react-router-dom"

const BoxStyled = styled(Box)({
  height: 200,
  width: "100%",
  cursor: "pointer",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  backgroundSize: "cover",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
})
const TypographyStyled = styled(Typography)({
  color: "red",
  textDecoration: "none",
  background: "white",
  opacity: "0.8",
  "&:hover": {
    opacity: "0.9",
    color: "black",
  },
})

const Categories = () => {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={{ xs: 1, sm: 2, md: 4 }}
      marginTop={4}
    >
      <BoxStyled sx={{ backgroundImage: `url(${busPosts})` }}>
        <TypographyStyled
          variant="h3"
          align="center"
          component={Link}
          to="/posts"
        >
          Posts
        </TypographyStyled>
      </BoxStyled>
      <BoxStyled sx={{ backgroundImage: `url(${busQuestions})` }}>
        <TypographyStyled
          variant="h3"
          align="center"
          component={Link}
          to="/quiz"
        >
          Quiz
        </TypographyStyled>
      </BoxStyled>
      <BoxStyled sx={{ backgroundImage: `url(${busJobs})` }}>
        <TypographyStyled
          variant="h3"
          align="center"
          component={Link}
          to="/jobs"
        >
          Jobs
        </TypographyStyled>
      </BoxStyled>
    </Stack>
  )
}
export default Categories
